module.exports = __webpack_public_path__ + "img/Credit-Card-CMC-Symbol.24901721.svg";